import React, { useEffect, useState } from "react";
import Safety1 from '../../../../assets/images/Safety1.png'
import Safety2 from '../../../../assets/images/Safety2.png'
import Safety3 from '../../../../assets/images/Safety3.png'
const Control = () => {
  const [active, setActive] = useState(0);
  const content = [
    {
      title: "Advanced Cargo Protection Measures",
      description:
        "Every shipment benefits from secure loading and protective measures designed to keep your goods safe from damage in transit.",
    },
    {
      title: "Environmental Safety Commitment",
      description:
        "ZOWO green initiatives focus on lowering carbon emissions while maintaining safe, timely deliveries across the entire network.",
    },
    {
      title: "Transparent Incident Reporting System",
      description:
        "Any issues during delivery are promptly reported and addressed through ZOWO transparent and accountable incident management system.",
    },
  ];
  const tabs = ["Cargo Safety", "Eco Delivery", "Incident Reporting"];
  useEffect(()=>{
    setTimeout(()=>{
      if(active==0){
        setActive(1);
      }else if(active==1){
        setActive(2);
      }else if(active==2){
        setActive(0);
      }
    },5000)
  },[])
  return (
    <div className="control-container">
      <div className="safety-details">
        <div className="control-icon-container">
          {active == 0 ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <g clip-path="url(#clip0_3213_2028)">
                <path
                  d="M15.0514 0.399902C15.3601 0.696222 15.6061 1.0619 15.7616 1.4775C16.0516 2.25262 16.7333 2.52886 17.2746 2.52886C17.8158 2.52886 18.4975 2.2527 18.7874 1.47758C18.9429 1.06198 19.189 0.696302 19.4977 0.399902H15.0514ZM17.2745 1.82558C16.9978 1.82558 16.7735 1.60078 16.7735 1.32342C16.7735 1.04614 16.9978 0.821262 17.2745 0.821262C17.5511 0.821262 17.7754 1.04606 17.7754 1.32342C17.7754 1.60078 17.5512 1.82558 17.2745 1.82558Z"
                  fill="white"
                />
                <path
                  d="M30.3155 9.66297V7.86144C30.3155 7.63592 30.1328 7.45312 29.9074 7.45312C29.6819 7.45312 29.4992 7.63592 29.4992 7.86144V9.66297C29.6344 9.65601 29.7705 9.65248 29.9074 9.65248C30.0442 9.65248 30.1803 9.65601 30.3155 9.66297Z"
                  fill="white"
                />
                <path
                  d="M29.4992 25.4883V27.2898C29.4992 27.5153 29.6819 27.6981 29.9074 27.6981C30.1328 27.6981 30.3155 27.5153 30.3155 27.2898V25.4883C30.1803 25.4952 30.0442 25.4988 29.9074 25.4988C29.7705 25.4988 29.6344 25.4952 29.4992 25.4883Z"
                  fill="white"
                />
                <path
                  d="M39.5919 17.1675H37.7949C37.8018 17.3028 37.8053 17.4388 37.8053 17.5758C37.8053 17.7128 37.8018 17.8488 37.7949 17.9841H39.5919C39.8173 17.9841 40 17.8013 40 17.5758C40 17.3503 39.8173 17.1675 39.5919 17.1675Z"
                  fill="white"
                />
                <path
                  d="M29.9074 17.7633C31.1827 17.7633 32.2203 16.7221 32.2203 15.4422C32.2203 14.1624 31.1827 13.1211 29.9074 13.1211C28.632 13.1211 27.5944 14.1624 27.5944 15.4422C27.5944 16.7221 28.632 17.7633 29.9074 17.7633Z"
                  fill="white"
                />
                <path
                  d="M36.4267 17.5757C36.4267 17.3502 36.6095 17.1674 36.8349 17.1674H37.7949C37.5892 13.1232 34.3467 9.86997 30.3155 9.66309V10.627C30.3155 10.8525 30.1328 11.0353 29.9074 11.0353C29.6819 11.0353 29.4992 10.8525 29.4992 10.627V9.66309C25.4682 9.86997 22.2256 13.1232 22.0199 17.1674H22.9798C23.2053 17.1674 23.388 17.3502 23.388 17.5757C23.388 17.8012 23.2053 17.984 22.9798 17.984H22.0199C22.2256 22.0282 25.4681 25.2815 29.4992 25.4884V24.5244C29.4992 24.2989 29.6819 24.1161 29.9074 24.1161C30.1328 24.1161 30.3155 24.2989 30.3155 24.5244V25.4884C34.3466 25.2815 37.5892 22.0282 37.7949 17.984H36.8349C36.6095 17.984 36.4267 17.8012 36.4267 17.5757ZM34.6694 22.4388C34.6694 22.6644 34.4867 22.8472 34.2612 22.8472C34.0358 22.8472 33.853 22.6644 33.853 22.4388V21.5654C33.853 20.0617 33.0074 18.6978 31.6798 18.028C30.6237 18.7555 29.1912 18.7555 28.1351 18.028C26.8074 18.6978 25.9618 20.0618 25.9618 21.5654V22.4388C25.9618 22.6644 25.7791 22.8472 25.5537 22.8472C25.3282 22.8472 25.1455 22.6644 25.1455 22.4388V21.5654C25.1455 19.8544 26.054 18.294 27.5018 17.4444C27.0507 16.9007 26.7782 16.203 26.7782 15.4421C26.7782 13.712 28.1819 12.3044 29.9074 12.3044C31.633 12.3044 33.0367 13.712 33.0367 15.4421C33.0367 16.2032 32.7646 16.9014 32.3134 17.4452C33.7608 18.2948 34.6694 19.8547 34.6694 21.5654V22.4388Z"
                  fill="white"
                />
                <path
                  d="M1.44768 10.8999C1.27624 10.6595 1.17432 10.3662 1.17432 10.0491C1.17432 9.23851 1.83352 8.57907 2.64368 8.57907C3.45384 8.57907 4.11304 9.23851 4.11304 10.0491C4.11304 10.1767 4.09496 10.3 4.06424 10.4183L5.57824 11.3178C5.84416 11.053 6.2104 10.889 6.61424 10.889C6.63528 10.889 6.65576 10.8912 6.67664 10.8922L7.39928 8.69931C7.01576 8.43379 6.7636 7.99115 6.7636 7.49027C6.7636 6.67971 7.4228 6.02027 8.23296 6.02027C9.04312 6.02027 9.70232 6.67971 9.70232 7.49027C9.70232 7.66115 9.67152 7.82451 9.61768 7.97723L11.1427 9.11395C11.5769 8.78363 12.168 8.72219 12.6605 8.95771L14.7526 6.59643V4.06299H0V12.7249L1.44768 10.8999Z"
                  fill="white"
                />
                <path
                  d="M6.61431 13.0123C6.97498 13.0123 7.26735 12.7198 7.26735 12.3589C7.26735 11.9981 6.97498 11.7056 6.61431 11.7056C6.25365 11.7056 5.96127 11.9981 5.96127 12.3589C5.96127 12.7198 6.25365 13.0123 6.61431 13.0123Z"
                  fill="white"
                />
                <path
                  d="M2.64376 10.7022C3.00443 10.7022 3.2968 10.4097 3.2968 10.0489C3.2968 9.68803 3.00443 9.39551 2.64376 9.39551C2.2831 9.39551 1.99072 9.68803 1.99072 10.0489C1.99072 10.4097 2.2831 10.7022 2.64376 10.7022Z"
                  fill="white"
                />
                <path
                  d="M8.23312 8.14363C8.59378 8.14363 8.88616 7.85111 8.88616 7.49027C8.88616 7.12943 8.59378 6.83691 8.23312 6.83691C7.87245 6.83691 7.58008 7.12943 7.58008 7.49027C7.58008 7.85111 7.87245 8.14363 8.23312 8.14363Z"
                  fill="white"
                />
                <path
                  d="M12.0298 10.9366C12.3904 10.9366 12.6828 10.6441 12.6828 10.2832C12.6828 9.9224 12.3904 9.62988 12.0298 9.62988C11.6691 9.62988 11.3767 9.9224 11.3767 10.2832C11.3767 10.6441 11.6691 10.9366 12.0298 10.9366Z"
                  fill="white"
                />
                <path
                  d="M13.271 9.50012C13.4146 9.72716 13.4991 9.99532 13.4991 10.2833C13.4991 11.0939 12.8399 11.7533 12.0298 11.7533C11.2196 11.7533 10.5604 11.0939 10.5604 10.2833C10.5604 10.1021 10.5949 9.92916 10.6551 9.76876L9.14352 8.64204C8.86832 8.86028 8.52432 8.9714 8.174 8.95732L7.45072 11.152C7.83272 11.4178 8.08376 11.8594 8.08376 12.3591C8.08376 13.1696 7.42456 13.8291 6.6144 13.8291C5.80424 13.8291 5.14504 13.1696 5.14504 12.3591C5.14504 12.2468 5.15888 12.1378 5.1828 12.0326L3.64712 11.1201C3.23128 11.5102 2.61464 11.626 2.08656 11.4086L0 14.0388V15.3883H14.7529V7.82764L13.271 9.50012Z"
                  fill="white"
                />
                <path
                  d="M26.9573 9.34982V1.66534C26.9573 0.967582 26.3914 0.399902 25.6957 0.399902H21.515C20.6461 0.399902 19.8573 0.947982 19.552 1.76382C19.1925 2.72462 18.2986 3.3455 17.2746 3.3455C16.2506 3.3455 15.3565 2.7247 14.997 1.76382C14.6918 0.948062 13.903 0.399902 13.0341 0.399902H8.85335C8.15775 0.399902 7.59175 0.967582 7.59175 1.66534V3.24622H15.161C15.3865 3.24622 15.5692 3.42902 15.5692 3.65454V15.7964C15.5692 16.0219 15.3865 16.2047 15.161 16.2047H7.59175V28.747C8.69479 29.1001 9.68295 29.7781 10.4164 30.6869H26.9573V25.8012C23.6246 24.602 21.3656 21.5257 21.2035 17.9838H20.2229C19.9974 17.9838 19.8147 17.801 19.8147 17.5755C19.8147 17.35 19.9974 17.1672 20.2229 17.1672H21.2035C21.3656 13.6253 23.6246 10.5489 26.9573 9.34982Z"
                  fill="white"
                />
                <path
                  d="M17.2745 34.2532C17.6485 34.2532 17.9517 33.949 17.9517 33.5736C17.9517 33.1983 17.6485 32.894 17.2745 32.894C16.9005 32.894 16.5973 33.1983 16.5973 33.5736C16.5973 33.949 16.9005 34.2532 17.2745 34.2532Z"
                  fill="white"
                />
                <path
                  d="M10.9717 31.5034C11.4769 32.3957 11.7409 33.3977 11.7409 34.4411C11.7409 34.8194 11.7049 35.197 11.6336 35.5689H25.6956C26.3912 35.5689 26.9572 35.0013 26.9572 34.3036V31.5035L10.9717 31.5034ZM17.2745 35.0701C16.4509 35.0701 15.781 34.3989 15.781 33.5738C15.781 32.7488 16.451 32.0776 17.2745 32.0776C18.0981 32.0776 18.768 32.7488 18.768 33.5738C18.768 34.3989 18.0981 35.0701 17.2745 35.0701Z"
                  fill="white"
                />
                <path
                  d="M5.78183 29.2822C2.94607 29.2822 0.638947 31.5965 0.638947 34.4409C0.638947 37.2854 2.94599 39.5997 5.78183 39.5997C8.61767 39.5997 10.9247 37.2855 10.9247 34.441C10.9247 31.5965 8.61759 29.2822 5.78183 29.2822ZM7.96583 37.2061C7.79567 37.3493 7.53383 37.3266 7.39071 37.1564L5.48663 34.891C5.42479 34.8174 5.39087 34.7244 5.39087 34.6282V31.3485C5.39087 31.1229 5.57359 30.9401 5.79903 30.9401C6.02447 30.9401 6.20719 31.1229 6.20719 31.3485V34.4793L8.01551 36.6308C8.16063 36.8034 8.13831 37.061 7.96583 37.2061Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_3213_2028">
                  <rect width="40" height="40" fill="white" />
                </clipPath>
              </defs>
            </svg>
          ) : active == 1 ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <g clip-path="url(#clip0_3213_2054)">
                <path
                  d="M2.34375 2.34375H4.31328V0H0V4.31336H2.34375V2.34375Z"
                  fill="white"
                />
                <path d="M0 7.13721H2.34375V11.4506H0V7.13721Z" fill="white" />
                <path d="M0 14.2749H2.34375V18.5883H0V14.2749Z" fill="white" />
                <path d="M28.5494 0H32.8627V2.34375H28.5494V0Z" fill="white" />
                <path d="M21.412 0H25.7253V2.34375H21.412V0Z" fill="white" />
                <path d="M14.2747 0H18.588V2.34375H14.2747V0Z" fill="white" />
                <path d="M7.13734 0H11.4506V2.34375H7.13734V0Z" fill="white" />
                <path
                  d="M35.6867 0V2.34375H37.6563V4.31336H40V0H35.6867Z"
                  fill="white"
                />
                <path
                  d="M37.6562 7.13721H40V11.4506H37.6562V7.13721Z"
                  fill="white"
                />
                <path
                  d="M37.6562 14.2749H40V18.5883H37.6562V14.2749Z"
                  fill="white"
                />
                <path
                  d="M37.6562 21.4121H40V25.7255H37.6562V21.4121Z"
                  fill="white"
                />
                <path
                  d="M37.6562 28.5493H40V32.8627H37.6562V28.5493Z"
                  fill="white"
                />
                <path
                  d="M37.6563 37.6561H35.6867V39.9999H40V35.6865H37.6563V37.6561Z"
                  fill="white"
                />
                <path
                  d="M28.5494 37.6562H32.8627V40H28.5494V37.6562Z"
                  fill="white"
                />
                <path
                  d="M21.412 37.6562H25.7253V40H21.412V37.6562Z"
                  fill="white"
                />
                <path d="M0 21.4121H18.588V40.0001H0V21.4121Z" fill="white" />
                <path
                  d="M28.1221 9.05713H29.2854L22.9941 15.3484V14.1851H20.6504V19.3494H25.8147V17.0056H24.6514L30.9427 10.7143V11.8777H33.2864V6.71338H28.1221V9.05713Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_3213_2054">
                  <rect width="40" height="40" fill="white" />
                </clipPath>
              </defs>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M31.745 5.82019L22.5433 2.36686C20.89 1.74686 19.09 1.74686 17.4567 2.36686L8.235 5.82019C6.16666 6.60519 4.78166 8.61186 4.78166 10.8235V20.1702C4.78166 24.2435 6.64333 27.7585 9.08166 30.6335C11.5017 33.4869 14.4783 35.7002 16.7117 37.1269C17.725 37.7685 18.8617 38.0985 20 38.0985C21.1383 38.0985 22.275 37.7685 23.2883 37.1269C27.7333 34.2735 35.22 28.2969 35.22 20.1702V10.8235C35.22 8.61186 33.8117 6.60519 31.745 5.82019ZM27.485 16.5519L20.6617 23.3552C19.9583 24.0585 19.0283 24.4102 18.1183 24.4102C17.1883 24.4102 16.2567 24.0585 15.555 23.3552L12.8867 20.6869C12.2667 20.0869 12.2667 19.0952 12.8867 18.4952C13.4867 17.8752 14.4583 17.8752 15.0783 18.4952L17.745 21.1635C17.9517 21.3702 18.2617 21.3702 18.4683 21.1635L25.2917 14.3602C25.8917 13.7402 26.8633 13.7402 27.4833 14.3602C28.0833 14.9602 28.085 15.9519 27.485 16.5519Z"
                fill="white"
              />
            </svg>
          )}
        </div>
        <span className="title">{content[active].title}</span>
        <span className="description">{content[active].description}</span>
        <div className="control-text-container">
          {tabs.map((item, index) => {
            return (
              <div
                onClick={() => {
                  setActive(index);
                }}
                className={`tab-item ${active === index ? "active" : ""}`}
              >
                <span className="trust">{item}</span>
                <div className="border"></div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="mobile-image-container">
        {active==0?<img src={Safety1}></img>:active==1?<img src={Safety2}></img>:<img src={Safety3}></img>}
      </div>
    </div>
  );
};

export default Control;
